import { useEffect, useState } from "react";
import { Pencil, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";

const inputCls = "w-full h-11 px-4 bg-[#0F1115] border border-[#272B33] rounded-xl text-sm text-white focus:outline-none focus:border-blue-500";
const EMPTY = { title: "", subtitle: "", image_url: "", link_url: "", button_text: "", position: "hero", order: 0, active: true };

export default function BannersPage() {
  const [banners, setBanners] = useState([]);
  const [form, setForm] = useState(null);

  const load = () => api.get("/admin/banners").then(({ data }) => setBanners(data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      const payload = { ...form, order: parseInt(form.order) || 0 };
      if (form.banner_id) await api.put(`/admin/banners/${form.banner_id}`, payload);
      else await api.post("/admin/banners", payload);
      toast.success("Banner kaydedildi"); setForm(null); load();
    } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div className="space-y-5" data-testid="admin-banners">
      <div className="flex items-center justify-between">
        <h1 className="font-display font-extrabold text-2xl text-white">Bannerlar</h1>
        <button onClick={() => setForm(EMPTY)} className="h-10 px-4 rounded-xl bg-blue-600 text-white text-sm font-semibold flex items-center gap-2 hover:bg-blue-500" data-testid="banner-new">
          <Plus size={15} /> Yeni Banner
        </button>
      </div>

      {form && (
        <form onSubmit={save} className="bg-[#181B20] border border-[#272B33] rounded-2xl p-5 grid sm:grid-cols-2 lg:grid-cols-3 gap-3 items-end" data-testid="banner-form">
          <input required placeholder="Başlık *" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className={inputCls} data-testid="banner-title" />
          <input placeholder="Alt başlık" value={form.subtitle || ""} onChange={(e) => setForm({ ...form, subtitle: e.target.value })} className={inputCls} />
          <input required placeholder="Görsel URL *" value={form.image_url} onChange={(e) => setForm({ ...form, image_url: e.target.value })} className={inputCls} data-testid="banner-image" />
          <input placeholder="Bağlantı (örn. /kategori/giyim)" value={form.link_url || ""} onChange={(e) => setForm({ ...form, link_url: e.target.value })} className={inputCls} />
          <input placeholder="Buton metni" value={form.button_text || ""} onChange={(e) => setForm({ ...form, button_text: e.target.value })} className={inputCls} />
          <input type="number" placeholder="Sıra" value={form.order} onChange={(e) => setForm({ ...form, order: e.target.value })} className={inputCls} />
          <div className="flex gap-2 items-center">
            <label className="flex items-center gap-2 text-sm text-neutral-300"><input type="checkbox" checked={form.active} onChange={(e) => setForm({ ...form, active: e.target.checked })} className="accent-blue-500 w-4 h-4" /> Aktif</label>
            <button type="submit" className="h-11 px-5 rounded-xl bg-blue-600 text-white text-sm font-semibold" data-testid="banner-save">Kaydet</button>
            <button type="button" onClick={() => setForm(null)} className="h-11 px-4 rounded-xl border border-[#272B33] text-sm text-neutral-400">Vazgeç</button>
          </div>
        </form>
      )}

      <div className="grid sm:grid-cols-2 gap-4">
        {banners.map((b) => (
          <div key={b.banner_id} className="bg-[#181B20] border border-[#272B33] rounded-2xl overflow-hidden" data-testid={`banner-card-${b.banner_id}`}>
            <div className="h-36 relative">
              <img src={b.image_url} alt="" className="w-full h-full object-cover" />
              {!b.active && <span className="absolute top-3 left-3 text-[10px] font-bold bg-rose-500 text-white px-2 py-1 rounded-full">PASİF</span>}
            </div>
            <div className="p-4 flex items-center justify-between">
              <div>
                <p className="font-semibold text-white text-sm">{b.title}</p>
                <p className="text-[11px] text-neutral-500">{b.link_url || "—"} · Sıra: {b.order}</p>
              </div>
              <div className="flex gap-1">
                <button onClick={() => setForm({ ...EMPTY, ...b })} className="p-2 text-neutral-400 hover:text-blue-400" data-testid="banner-edit"><Pencil size={15} /></button>
                <button onClick={async () => { await api.delete(`/admin/banners/${b.banner_id}`); load(); }} className="p-2 text-neutral-400 hover:text-rose-400" data-testid="banner-delete"><Trash2 size={15} /></button>
              </div>
            </div>
          </div>
        ))}
        {banners.length === 0 && <p className="text-neutral-500 text-sm col-span-2 text-center py-10">Banner yok</p>}
      </div>
    </div>
  );
}
